import { render } from "./CustomerBusinessDetails.vue?vue&type=template&id=3fb8592f&scoped=true"
import script from "./CustomerBusinessDetails.vue?vue&type=script&lang=js"
export * from "./CustomerBusinessDetails.vue?vue&type=script&lang=js"

import "./CustomerBusinessDetails.vue?vue&type=style&index=0&id=3fb8592f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb8592f"]])

export default __exports__